module.exports = __webpack_public_path__ + "static/img/deve4.42d0160.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/deve4.png
// module id = 2TRk
// module chunks = 1